import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from '@pearsontechnology/aero-components';
import { findPropertiesByType } from '@pearsontechnology/aero-plugin-schema';
import { Formik, Field } from 'formik';
import pathwayTypesConstants from 'constants/pathwayTypes';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import pluginTypes from 'constants/pluginTypes';

import {
  CardRow,
  Label,
  SelectWrapper,
  Select,
  CaretDown,
} from './styles';
import messages from './messages';
import { getPathwayOptions } from './pathwayHelpers';

/**
 * Provides the step to create a pathway for Course/Unit/Lesson in PluginSelectionModal
 *
 * @param {object}    selectedActivity  plugin information for selected courseware
 * @param {function}  onPathwayTypeSelect   A function that provides ability to create pathway upon confirmation of selection
 *
 */
function PluginSelection2ndStep({ selectedActivity, onPathwayTypeSelect }) {
  const contentProperties = findPropertiesByType(
    selectedActivity.pluginSchema,
    pluginTypes.PATHWAY,
  );

  return (
    <Formik
      onSubmit={(values) => {
        const pathwayTypes = [];
        for (let i = 0; i < values.pathwayTypes.length; i += 1) {
          pathwayTypes.push({ key: contentProperties[i].path, value: values.pathwayTypes[i] });
        }
        onPathwayTypeSelect(pathwayTypes);
      }}
      initialValues={{ pathwayTypes: Array.from({ length: contentProperties.length }, () =>
        selectedActivity.pluginType === pluginTypes.COURSE ? pathwayTypesConstants.FREE : ''
      )}}
      validate={(values) => {
        const errors = {};
        if (!values.pathwayTypes.every((value) => !!value)) {
          errors.pathwayTypes = 'Not all pathway types filled in';
        }
        return errors;
      }}
    >
      {({ handleSubmit, isValid, isSubmitting }) => (
        <React.Fragment>
          <Card width={600}>
            {contentProperties.map((contentProperty, index) => (
              <CardRow key={contentProperty.label}>
                <Label>{contentProperty.label || contentProperty.path[contentProperty.path.length - 1]}</Label>

                <Field name={`pathwayTypes[${index}]`}>
                  {({ field, form, ...props }) => (
                    <SelectWrapper>
                      <Select {...field} {...props} notSelected={!field.value}>
                        <option value="" disabled>{intl.formatMessage(messages.dropdownPlaceholder)}</option>
                        {getPathwayOptions(selectedActivity.pluginType, contentProperty.property?.allowedTypes).map((pathwayOption) => (
                          <option key={pathwayOption.pathwayType} value={pathwayOption.pathwayType}>
                            {intl.formatMessage(pathwayOption.messages)}
                          </option>
                        ))}
                      </Select>
                      <CaretDown viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 10l5 5 5-5z" />
                      </CaretDown>
                    </SelectWrapper>
                  )}
                </Field>
              </CardRow>
            ))}
          </Card>

          <Button type="button" primary onClick={handleSubmit} disabled={(isSubmitting || !isValid) && selectedActivity.pluginType !== pluginTypes.COURSE} width={146} style={{ marginTop: 40 }}>{intl.formatMessage(messages.continue)}</Button>
        </React.Fragment>
      )}
    </Formik>
  );
}

PluginSelection2ndStep.propTypes = {
  selectedActivity: PropTypes.shape({
    pluginId: PropTypes.string,
    version: PropTypes.string,
    pluginType: PropTypes.string,
    pluginSchema: PropTypes.object,
  }),
  onPathwayTypeSelect: PropTypes.func,
};

export default PluginSelection2ndStep;
